export { DeclaracionRoles, RolTreeType } from "app/models/requireme";



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/rolmap.tsx